/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
function toDisposable(fn) {
    return {
        dispose: fn
    };
}
class BugIndicatingError extends Error {
    constructor(message) {
        super(message || 'An unexpected bug occurred.');
        Object.setPrototypeOf(this, BugIndicatingError.prototype);
        // Because we know for sure only buggy code throws this,
        // we definitely want to break here and fix the bug.
        // eslint-disable-next-line no-debugger
        // debugger;
    }
}
function onBugIndicatingError(error) {
    // debugger;
    throw error;
}
function onUnexpectedError(error) {
    console.error('Unexpected error:', error);
}
/**
 * Compares two items for equality using strict equality.
*/
const strictEquals = (a, b) => a === b;

export { BugIndicatingError, onBugIndicatingError, onUnexpectedError, strictEquals, toDisposable };
//# sourceMappingURL=deps.js.map
